import styled, { css } from 'styled-components';
import MaskedInput from "react-text-mask";

export const ProfileContainer = styled.main`
  flex-grow: 1;
  padding: 0 25px;
  padding-bottom: 55px;

  @media(min-width: 768px) {
    display: flex;
    align-items: flex-start;
    padding: 0 40px;
    padding-top: 50px;
    padding-bottom: 80px;
  }

  @media(min-width: 1024px) {
    max-width: 1210px;
    width: 100%;
    margin: 0 auto;
    padding-top: 70px;
    padding-bottom: 120px;
  }
`;

export const ProfileHeading = styled.h2`
  margin: 0;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 0;

  font-size: 22px;
  line-height: 1;

  @media(min-width: 768px) {
    margin-top: 0;

    font-size: 36px;
  }
`;

export const ProfileNavigation = styled.aside`
  flex-shrink: 0;
  margin-bottom: 30px;

  ${({ isInnerPage }) => isInnerPage && css`
    display: block;

    @media(min-width: 768px) {
      display: block;
    }
  `};

  @media(min-width: 768px) {
    width: 315px;
    margin-bottom: 0;

    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }
`;

export const UserContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 30px 0;
  padding-top: 0;
  padding-bottom: 25px;

  border-bottom: 1px solid ${({ theme }) => theme.lightGray};

  @media(min-width: 768px) {
    padding: 30px;
  }
`;

export const Icon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  margin-right: 5px;

  border-radius: 50%;
`;

export const ProfileList = styled.ul`
  display: none;

  @media(min-width: 768px) {
    display: block;
    margin-top: 15px;
  }
`;

export const ProfileItem = styled.li`
  @media(min-width: 768px) {
    a {
      display: flex;
      align-items: center;
      padding: 5px 20px;

      font-size: 16px;
      color: inherit;

      transition: color 0.3s;

      &:hover {
        color: ${({ theme }) => theme.blue};
      }
    }

    ${({ isActive }) => isActive && css`
      ${Icon} {
        background-color: #f8f8f8;
      }
    `}
  }
`;

export const LogoutButton = styled.button`
  display: none;

  @media(min-width: 768px) {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 25px;
    padding: 20px;

    background-color: transparent;
    border: none;
    border-top: 1px solid ${({ theme }) => theme.lightGray};
    outline: none;

    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: ${({ theme }) => theme.blue};
    }
  }
`;

export const ProfileContent = styled.section`
  @media(min-width: 768px) {
    flex-grow: 1;
    margin-left: 50px;
  }

  @media(min-width: 1024px) {
    margin-left: 65px;
  }
`;

export const ProfileInput = styled(MaskedInput)`
  width: 100%;
  margin: 0;
  padding: 15px 20px;
  padding-right: 35px;
  
  font-family: inherit;
  font-size: 16px;
  line-height: 1;
  color: inherit;
  
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.lightGray};
  border-radius: 6px;
  outline: none;
  
  transition: border-color 0.3s;
  
  &::placeholder {
    color: inherit;
    opacity: 0.5;
  }
  
  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.blue};
  }
`;

export const ProfileInputItem = styled.li`
  width: 100%;
  margin-bottom: 15px;

  &:not(:last-child) {
    margin-bottom: 25px;
  }

  @media(min-width: 1024px) {
    width: 47.36%;
    margin-bottom: 0;
  }

  p {
    margin: 0;
    margin-bottom: 5px;
    padding: 0;

    font-size: 14px;
    line-height: 1;

    & + div {
      border-radius: 6px;
    }
  }
`;

export const ProfileInputList = styled.ul`
  display: flex;
  flex-direction: ${({ column }) => column ? 'column' : 'row'};
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;

  ${({ column }) => column && css`
    ${ProfileInputItem} {
      width: 100%;
    }
  `}
`;

export const ProfileButtonContainer = styled.div`
  margin-top: 30px;

  button {
    padding-left: 30px;
    padding-right: 30px;
  }
`;

export const ProfileColumns = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media(min-width: 1024px) {
    flex-direction: row;
  }
`;

export const ProfileColumn = styled.div`
  width: 100%;

  &:last-child {
    padding-bottom: 30px;
  }

  @media(min-width: 768px) {
    &:last-child {
      padding-bottom: 20px;
    }
  }

  @media(min-width: 1024px) {
    &:last-child {
      width: 260px;
    }
  }
`;

export const InfoMessage = styled.p`
  font-size: 16px;
  color: ${({ type, theme }) => type === 'success' ? theme.green : theme.red};
`;
